var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"game",attrs:{"id":"game","src":_vm.game_url,"frameborder":"0","allowfullscreen":"","width":"100%","height":"100%","scrolling":"no"},on:{"load":function($event){return _vm.loaded()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }